import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

// Generic scroll-reveal wrapper reused across every section.
export const Reveal = ({
  children,
  delay = 0,
  y = 40,
  className = "",
  as = "div",
  once = true,
  ...rest
}) => {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, ease: easing, delay }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};

// Masked line-by-line reveal (each line slides up from behind a clip mask).
export const MaskLines = ({ lines, className = "", lineClassName = "", start = 0.2, ...rest }) => {
  return (
    <span className={className} {...rest}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.15, ease: easing, delay: start + i * 0.14 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
